import BaseApi from '../BaseApi';

class OrdersExportApi extends BaseApi {
  getOrdersExport(params: any) {
    return this.get('/export', params);
  }

  protected getSpecificApiPrefix(): string {
    return 'v2/managers/orders';
  }
}

export default OrdersExportApi;
